module.exports = __webpack_public_path__ + "ath_game_web/img/2.3.b750fa22.png";